import React from "react";

export function resolveEntityType(entity) {
    if (entity === "userAccount") return "USER";
    if (entity === "company") return "COMP";
    if (entity === "department") return "DEPT";
    if (
        entity === "asset" ||
        entity === "asset-diligence" ||
        entity === "maintenance-assets" ||
        entity === "depreciationAsset"
    ) {
        return "ASSET";
    }
    if (entity === "contract") return "CONTRACT";
    return "CODE";
}

function EntityTypeIcon({entity, className, style}) {
    const type = resolveEntityType(entity);

    if (type === "USER") {
        return (
            <svg className={className ?? ""} style={style} viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M12 12a4.5 4.5 0 1 0-4.5-4.5A4.5 4.5 0 0 0 12 12Z" stroke="currentColor" strokeWidth="2"/>
                <path d="M4 20c1.6-4 14.4-4 16 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
        );
    }

    if (type === "COMP") {
        return (
            <svg className={className ?? ""} style={style} viewBox="0 0 24 24" fill="none">
                <path d="M4 20V6l8-3 8 3v14H4Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
                <path d="M9 20v-6h6v6" stroke="currentColor" strokeWidth="2"/>
            </svg>
        );
    }

    if (type === "DEPT") {
        return (
            <svg className={className ?? ""} style={style} viewBox="0 0 24 24" fill="none">
                <path d="M6 20V8l6-3 6 3v12" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
                <path d="M9 12h6M9 16h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
        );
    }

    if (type === "ASSET") {
        return (
            <svg className={className ?? ""} style={style} viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M4 7h16v10H4V7Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
                <path d="M8 11h8M8 14h5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
        );
    }

    if (type === "CONTRACT") {
        return (
            <svg className={className ?? ""} style={style} viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                    d="M5.5 8C6.88071 8 8 6.88071 8 5.5C8 4.11929 6.88071 3 5.5 3C4.11929 3 3 4.11929 3 5.5C3 6.88071 4.11929 8 5.5 8ZM5.5 8V16M5.5 16C4.11929 16 3 17.1193 3 18.5C3 19.8807 4.11929 21 5.5 21C6.88071 21 8 19.8807 8 18.5C8 17.1193 6.88071 16 5.5 16ZM16 12C16 13.3807 17.1193 14.5 18.5 14.5C19.8807 14.5 21 13.3807 21 12C21 10.6193 19.8807 9.5 18.5 9.5C17.1193 9.5 16 10.6193 16 12Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        );
    }

    return (
        <svg className={className ?? ""} style={style} viewBox="0 0 24 24" fill="none">
            <path d="M5.5 8C6.88071 8 8 6.88071 8 5.5C8 4.11929 6.88071 3 5.5 3C4.11929 3 3 4.11929 3 5.5C3 6.88071 4.11929 8 5.5 8ZM5.5 8V16M5.5 16C4.11929 16 3 17.1193 3 18.5C3 19.8807 4.11929 21 5.5 21C6.88071 21 8 19.8807 8 18.5C8 17.1193 6.88071 16 5.5 16ZM16 12C16 13.3807 17.1193 14.5 18.5 14.5C19.8807 14.5 21 13.3807 21 12C21 10.6193 19.8807 9.5 18.5 9.5C17.1193 9.5 16 10.6193 16 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}

export default EntityTypeIcon;
